import { render } from "./DesktopCouponView.vue?vue&type=template&id=eb4ec68e&scoped=true"
import script from "./DesktopCouponView.vue?vue&type=script&lang=js"
export * from "./DesktopCouponView.vue?vue&type=script&lang=js"

import "./DesktopCouponView.vue?vue&type=style&index=0&id=eb4ec68e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb4ec68e"]])

export default __exports__